import { SpinMutation3rsfya4nf2aew as SpinMutation } from './schema/SpinMutation.mjs';
import {
  Success_instance2p306gayageh9 as Success_instance,
  Dispatchernurlbopdkn3a as Dispatcher,
} from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/SpinCommand.mjs';
import { Unauthorized_instance3p96f1r9ta19w as Unauthorized_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { NotEmptyList__toList_impl_nbkblo1xb1zjd6musb4 as NotEmptyList__toList_impl_nbkblo } from '../../../../../types-types/kotools/types/collection/NotEmptyList.mjs';
import { SpinInputg1yg8g6z8wv9 as SpinInput } from './schema/type/SpinInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  var tmp0_safe_receiver = (yield* this.u6s(new (SpinMutation())(spinInput(command)), $completion)).c45_1;
  var tmp;
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z6i_1) == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Success_instance;
  }
  var tmp2_elvis_lhs = tmp;
  return tmp2_elvis_lhs == null ? Unauthorized_instance : tmp2_elvis_lhs;
}
var SdkSpinClass;
function SdkSpin() {
  if (SdkSpinClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkSpin', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkSpinClass = $;
  }
  return SdkSpinClass;
}
function spinInput(_this__u8e3s4) {
  return new (SpinInput())(_this__u8e3s4.x2j_1, NotEmptyList__toList_impl_nbkblo(_this__u8e3s4.y2j_1), _this__u8e3s4.z2j_1);
}
//region block: exports
export {
  SdkSpin as SdkSpin3glo2r2cb0vqe,
  perform as perform1gxruvgzh3z45,
};
//endregion

//# sourceMappingURL=SdkSpin.mjs.map
